export class VacancyStepCreateRequest {
    name: string
    vacancyId:number
    constructor() {
        this.name = ''
        this.vacancyId = 0
    }
}